var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label", attrs: { for: "" } }, [
        _vm._v(_vm._s(_vm.constants.STRINGS.COMMON_WORDS.TYPE)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "control" }, [
        _c("div", { staticClass: "select is-fullwidth" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query.tipoDocumento,
                  expression: "query.tipoDocumento",
                },
              ],
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.query,
                    "tipoDocumento",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            [
              _c("option", { domProps: { value: null } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.constants.STRINGS.COMMON_WORDS.DASH_ALL_DASH) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c(
                "option",
                {
                  domProps: {
                    value: _vm.constants.STRINGS.COMMON_WORDS.FOLDER_LOWERCASE,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.constants.STRINGS.COMMON_WORDS.FOLDERS) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "option",
                {
                  domProps: {
                    value:
                      _vm.constants.STRINGS.COMMON_WORDS.DOCUMENT_LOWERCASE,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.constants.STRINGS.COMMON_WORDS.DOCUMENTS) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              this.isAllowedToFilterOtherDocuments
                ? _c(
                    "option",
                    {
                      domProps: {
                        value:
                          _vm.constants.STRINGS.COMMON_WORDS
                            .OTHER_DOCUMENT_CAMEL_CASE,
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.constants.STRINGS.COMMON_WORDS.NOTIFICATIONS
                          ) +
                          "\n          "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.isAllowedToFilterReceipts
                ? _c(
                    "option",
                    {
                      domProps: {
                        value:
                          _vm.constants.STRINGS.COMMON_WORDS.RECEIPT_LOWERCASE,
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.constants.STRINGS.COMMON_WORDS.RECEIPTS) +
                          "\n          "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.isAllowedToFilterSeriesAndSubunits
                ? _c(
                    "option",
                    {
                      domProps: {
                        value:
                          _vm.constants.STRINGS.COMMON_WORDS.SUBUNIT_LOWERCASE,
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.constants.STRINGS.COMMON_WORDS.SUBUNITS) +
                          "\n          "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.isAllowedToFilterSeriesAndSubunits
                ? _c(
                    "option",
                    {
                      domProps: {
                        value:
                          _vm.constants.STRINGS.COMMON_WORDS
                            .COMPOUND_UNITS_CAMEL_CASE,
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.constants.STRINGS.COMMON_WORDS.COMPOUND_UNITS
                          ) +
                          "\n          "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    this.isAllowedToFilterAspects
      ? _c("div", { staticClass: "field is-clearfix" }, [
          _c("div", { staticClass: "control is-pulled-right" }, [
            _c("a", { on: { click: _vm.openAspectosModal } }, [
              _c("i", { staticClass: "fas fa-plus" }),
            ]),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "label is-pulled-left" }, [
            _vm._v(_vm._s(_vm.constants.STRINGS.COMMON_WORDS.ASPECTS)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c(
              "div",
              { staticClass: "tags" },
              _vm._l(_vm.aspectos, function (aspecto, i) {
                return _c("div", { key: i, staticClass: "tags has-addons" }, [
                  _c("span", { staticClass: "tag is-link" }, [
                    _vm._v(_vm._s(aspecto.name)),
                  ]),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "tag is-delete",
                    on: {
                      click: function ($event) {
                        return _vm.removeAspecto(aspecto)
                      },
                    },
                  }),
                ])
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    this.isAllowedToFilterAspects
      ? _c("div", { staticClass: "field is-clearfix" }, [
          _c("div", { staticClass: "control is-pulled-right" }, [
            _c("a", { on: { click: _vm.openMetadatosModal } }, [
              _c("i", { staticClass: "fas fa-plus" }),
            ]),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "label is-pulled-left" }, [
            _vm._v(_vm._s(_vm.constants.STRINGS.COMMON_WORDS.METADATA)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c(
              "div",
              { staticClass: "tags" },
              _vm._l(_vm.metadatos, function (metadato, i) {
                return _c("div", { key: i, staticClass: "tags has-addons" }, [
                  _c("span", { staticClass: "tag is-link" }, [
                    _vm._v(_vm._s(metadato.name)),
                  ]),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "tag is-delete",
                    on: {
                      click: function ($event) {
                        return _vm.removeMetadatosList(metadato.value)
                      },
                    },
                  }),
                ])
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    this.isCompoundUnit && this.isAllowedToFilterSeriesAndSubunits
      ? _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label", attrs: { for: "" } }, [
            _vm._v(_vm._s(_vm.constants.STRINGS.COMMON_WORDS.DOCUMENTAL_SERIE)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "control" },
            [
              _c("pertenencia-series-documentales", {
                on: {
                  setSerie: _vm.setSerieDocumental,
                  setEstadoSerie: _vm.setEstadoSerie,
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    this.isAllowedToFilterFolders
      ? _c(
          "div",
          { staticClass: "field is-clearfix" },
          [
            _c(
              "label",
              {
                staticClass: "label",
                class: { "is-pulled-left": _vm.explorerLoading },
              },
              [_vm._v(_vm._s(_vm.constants.STRINGS.COMMON_WORDS.ROOT_FOLDER))]
            ),
            _vm._v(" "),
            _vm.explorerLoading
              ? _c("i", {
                  staticClass:
                    "fas fa-lg fa-circle-notch fa-spin is-pulled-right",
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.selected
              ? _c(
                  "a",
                  {
                    staticClass: "is-pulled-right",
                    on: {
                      click: function ($event) {
                        _vm.selected = null
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selected
              ? _c("p", { staticClass: "help" }, [
                  _vm._v(_vm._s(_vm.selected.ruta)),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.selected
              ? _c(
                  "button",
                  {
                    staticClass:
                      "button is-primary is-small is-outlined is-fullwidth",
                    on: {
                      click: function ($event) {
                        _vm.showExplorerModal = true
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.constants.STRINGS.SUBTITLES.FILTERS_GENERAL_SEARCH
                          .CHOOSE_FOLDER
                      )
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "explorerModal",
                attrs: { active: _vm.showExplorerModal, scroll: "keep" },
                on: {
                  "update:active": function ($event) {
                    _vm.showExplorerModal = $event
                  },
                },
              },
              [
                _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-content" },
                    [
                      _c("h1", { staticClass: "title is-5" }, [
                        _c("i", { staticClass: "fas fa-arrow-right" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.constants.STRINGS.SUBTITLES
                                .FILTERS_GENERAL_SEARCH.CHOOSE_ROOT_FOLDER
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "control" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "button is-static is-fullwidth has-text-left",
                            },
                            [_vm._v(_vm._s(_vm.getRuta))]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("explorer", {
                        ref: "listado",
                        attrs: {
                          initFolder: _vm.initRoute,
                          slug: _vm.organizacionSlug,
                          rutas: _vm.rutas,
                          selected: _vm.selected,
                        },
                        on: {
                          "update:rutas": function ($event) {
                            _vm.rutas = $event
                          },
                          "update:selected": function ($event) {
                            _vm.selected = $event
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "help" }, [
                        _vm._v(
                          _vm._s(
                            _vm.constants.STRINGS.SUBTITLES
                              .FILTERS_GENERAL_SEARCH
                              .CHOOSE_FOLDER_WHERE_RECEIPTS_WILL_SAVE
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "button is-dark is-outlined is-fullwidth",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.$refs.explorerModal.close()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.constants.STRINGS.BUTTONS.CLOSE))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }